'use client';
import { useState } from 'react';
import RegisterWithPass from './RegisterWithPass';
import LoginWithOTP from '../login/LoginWithOTP';

const RegisterForm = () => {
  const [isPassword, setIsPassword] = useState(false);
  return (
    <>
      {isPassword ? <RegisterWithPass /> : <LoginWithOTP />}

      <div className="d-flex align-items-center my-4">
        <div className="flex-grow-1 border-top"></div>
        <span className="mx-3 text-muted small">Or Register With</span>
        <div className="flex-grow-1 border-top"></div>
      </div>
      <button
        onClick={() => setIsPassword(!isPassword)}
        className="trk-btn trk-btn--primary d-block mt-3"
      >
        {isPassword ? 'Register with OTP' : 'Register with password'}
      </button>
    </>
  );
};

export default RegisterForm;
